// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__GZY9I","label":"LabeledBox_label__1Li_4"};